require('dotenv').config()

import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import store from './store'
import router from './router'
import './ml'

import VueFormulate from '@braid/vue-formulate'
import {library} from '@fortawesome/fontawesome-svg-core'
import {
  faBan,
  faCartArrowDown,
  faCheckCircle,
  faDownload,
  faEdit,
  faExclamation,
  faExclamationCircle,
  faPencilAlt,
  faPlus,
  faQuestion,
  faQuestionCircle,
  faSearch,
  faSignInAlt,
  faSignOutAlt,
  faThumbsUp,
  faTimes,
  faTimesCircle,
  faTrash,
  faUser,
  faUserEdit,
} from '@fortawesome/free-solid-svg-icons'

import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import '@braid/vue-formulate/themes/snow/snow.scss'
import 'vue-search-select/dist/VueSearchSelect.css'

import titleMixin from './components/titleMixin'

Vue.use(VueFormulate)

library.add(
  faUser,
  faSignInAlt,
  faSignOutAlt,
  faUserEdit,
  faExclamationCircle,
  faEdit,
  faPlus,
  faCartArrowDown,
  faSearch,
  faTimes,
  faExclamation,
  faQuestion,
  faTrash,
  faTimesCircle,
  faQuestionCircle,
  faDownload,
  faThumbsUp,
  faBan,
  faCheckCircle,
  faPencilAlt,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

/*import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'*/

Vue.mixin(titleMixin)
Vue.config.productionTip = false


new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
